import React from 'react';
import { Box, Button, Card, CardContent, Container, Stack, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { mockOrders } from './mockOrders';

export default function LabOrderDetail() {
  const navigate = useNavigate();
  const { orderId } = useParams();
  const order = mockOrders.find((item) => item.orderId === orderId);

  return (
    <Container disableGutters sx={{ mt: 2, mb: 4 }}>
      <Box sx={{ maxWidth: 980, mx: 'auto' }}>
        <Stack spacing={2}>
          <Box>
            <Button variant="text" onClick={() => navigate('/mock/lab-dashboard#orders')}>
              Back to Orders
            </Button>
          </Box>

          <Card sx={{ border: '1px solid #d8e2e7', boxShadow: 'none', borderRadius: 3 }}>
            <CardContent sx={{ p: { xs: 2.5, md: 3 } }}>
              <Typography variant="h4" component="h1">
                Order Detail
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                Mock detail view for lab order review and tracking.
              </Typography>
            </CardContent>
          </Card>

          <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
            <Card sx={{ border: '1px solid #e5ebef', boxShadow: 'none', borderRadius: 2, flex: 1 }}>
              <CardContent>
                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                  Order
                </Typography>
                <Typography variant="body2"><strong>Order ID:</strong> {order?.orderId || orderId}</Typography>
                <Typography variant="body2"><strong>Status:</strong> {order?.status || 'Unknown'}</Typography>
                <Typography variant="body2"><strong>Received:</strong> 2026-02-26 09:14</Typography>
              </CardContent>
            </Card>

            <Card sx={{ border: '1px solid #e5ebef', boxShadow: 'none', borderRadius: 2, flex: 1 }}>
              <CardContent>
                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                  Patient / Provider
                </Typography>
                <Typography variant="body2"><strong>Patient:</strong> {order?.patient || 'Unknown'}</Typography>
                <Typography variant="body2"><strong>Provider:</strong> {order?.provider || 'Unknown'}</Typography>
                <Typography variant="body2"><strong>Specimen:</strong> Serum, 1 tube</Typography>
              </CardContent>
            </Card>
          </Stack>

          <Card sx={{ border: '1px solid #e5ebef', boxShadow: 'none', borderRadius: 2 }}>
            <CardContent>
              <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                Activity
              </Typography>
              <Typography variant="body2">1. 2026-03-01 08:43 | sam.tech@veravas.com | Sample scanned.</Typography>
              <Typography variant="body2">2. 2026-03-01 08:44 | sam.tech@veravas.com | Requisition confirmed.</Typography>
              <Typography variant="body2">3. 2026-03-01 08:46 | sam.tech@veravas.com | Intake completed.</Typography>
            </CardContent>
          </Card>
        </Stack>
      </Box>
    </Container>
  );
}
